import { render } from "./AppDeleteDialog.vue?vue&type=template&id=1f47a4c5"
import script from "./AppDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AppDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__